import { Transform } from 'class-transformer';
import {
  IsDefined,
  IsNumber,
  IsOptional,
  IsString,
  IsBoolean,
} from 'class-validator';
import { Dict } from '../../../models';
import { EcomBaseProduct } from './base-product';

export enum EcomAccessoryType {
  Genuine = 'Genuine',
  Kromozone = 'Kromozone',
}

export class EcomAccessory extends EcomBaseProduct {
  @IsOptional()
  @IsString()
  productCategoryName?: string;

  @IsOptional()
  @IsString()
  productImage?: string;

  @IsOptional()
  @IsString()
  productPreviewImage?: string;

  @IsOptional()
  productType?: string;

  @IsDefined()
  // @Transform(Number, { toClassOnly: true })
  @IsNumber()
  salesPrice!: number;

  @IsDefined()
  // @Transform(Number, { toClassOnly: true })
  @IsNumber()
  offerPrice!: number;

  @IsOptional()
  @Transform((v) => v === 'Yes')
  tintAvailable?: boolean;

  @IsOptional()
  @Transform((v) => v === 'Yes')
  checkRows?: boolean;

  @IsOptional()
  tintRows?: number;

  @IsDefined()
  @IsString()
  partNumber!: string;

  @IsOptional()
  @IsString()
  menuCode?: string;

  tintOptions?: {
    windsheild?: boolean;
    rear?: boolean;
  } & Dict;

  @IsOptional()
  @Transform((v) => v === 'Yes')
  @IsBoolean()
  interestedIn?: boolean;

  @IsOptional()
  @Transform((v) => v === 'Yes', { toClassOnly: true })
  @IsBoolean()
  includeinInsurance?: boolean;

  @IsDefined()
  @IsString()
  componentCode!: string;
}
